import React from "react";

// Labeled input with an optional error slot. Dark-theme styling.
export default function Field({
  label,
  id,
  error,
  hideLabel = false,
  className = "",
  ...props
}) {
  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={id}
          className={
            hideLabel
              ? "sr-only"
              : "mb-1.5 block text-sm font-medium text-white/80"
          }
        >
          {label}
        </label>
      )}
      <input
        id={id}
        className="block w-full rounded-xl border-white/10 bg-navy-900/60 px-4 py-2.5 text-white placeholder-white/40 shadow-sm transition-colors focus:border-accent focus:ring-accent sm:text-sm"
        {...props}
      />
      {error && (
        <p role="alert" className="mt-1.5 text-sm text-red-400">
          {error}
        </p>
      )}
    </div>
  );
}
